import { MedicalRecordNoTreatmentReason } from '@server/prisma-generated/enums';

export const NO_TREATMENT_REASON_LABELS: Record<MedicalRecordNoTreatmentReason, string> = {
    [MedicalRecordNoTreatmentReason.CURRENT_ANAMNESE]: 'aktuelle Anamnese (z.B. Infektion)',
    [MedicalRecordNoTreatmentReason.EXTERNAL_FACTORS]: 'externe Faktoren (z.B. UV-Exposition)',
    [MedicalRecordNoTreatmentReason.CONTRAINDICATION]: 'Kontraindikation',
    [MedicalRecordNoTreatmentReason.BODY_DYSMORPHIC_DISORDER]: 'BDD (Körperschemastörung)',
    [MedicalRecordNoTreatmentReason.INSUFFICIENT_TIME]: 'Nicht ausreichend Zeit',
    [MedicalRecordNoTreatmentReason.OTHER]: 'Sonstige',
};

export const NO_TREATMENT_REASON_OPTIONS = Object.entries(NO_TREATMENT_REASON_LABELS) as Array<
    [MedicalRecordNoTreatmentReason, string]
>;
